module.exports = __webpack_public_path__ + "img/city_2560.e2bdc861.svg";